import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const listWidth = '288px';
export const smallScreenListWidth = '205px';

interface TimesheetDetailContainerProps {
  showCrewMembers: boolean;
}

export const TimesheetDetailContainer = styled(Box).attrs({ flexDirection: { sm: 'column' } })<
  TimesheetDetailContainerProps
>`
  height: 100vh;
  overflow-y: hidden;
  ${(props) =>
    props.showCrewMembers &&
    css`
      position: absolute;
      left: ${listWidth};
      width: calc(100% - ${listWidth});
      @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
        left: ${smallScreenListWidth};
        width: calc(100% - ${smallScreenListWidth});
      }
    `}
`;
